import throttle from 'lodash/throttle'
import debounce from 'lodash/debounce'

(function($) {
    let scrollY = 0
    const scrollTarget = document.querySelector('.inner')
    const header = document.querySelector('.header')

    // early exit for the Age Gate screen where header doesn't exist
    if (!header) {
        return
    }

    let headerHeight = header.getBoundingClientRect().height

    const toggle = header.querySelector('.header__menu-toggle')
    toggle && toggle.addEventListener('click', function() {
        header.classList.toggle('header--menu-show')
    })

    // Make Header slide up/down based on the scroll direction
    scrollTarget.addEventListener('scroll', throttle(onWindowScroll, 200))

    // Debounced check for header position 200ms from the last scroll event
    scrollTarget.addEventListener('scroll', debounce(onWindowScroll, 200))

    // Attach debounced function to fire 100ms after last resize event
    window.addEventListener('resize', debounce(onWindowResize, 100))

    // Set appropriate top padding on .inner element
    // to account for the fixed header
    function onWindowResize() {
        headerHeight = header.getBoundingClientRect().height
        inner.style.paddingTop = headerHeight + 'px'
    }

    function onWindowScroll() {
        const newScrollY = scrollTarget.scrollTop

        // Early exit if the scrolled amount is lower than header height
        // And display the header
        if (newScrollY < headerHeight) {
            header.classList.remove('header--scroll-up')
            return false
        } else {
            header.classList.add('header--scroll-up')
        }

        scrollY = newScrollY
    }
})(jQuery)
